var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBuildings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: props.fill
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7 16.498a.8.8 0 01.8-.8H18a.8.8 0 110 1.6h-1.5a.8.8 0 01-.8-.8zM16.5 11.948a.8.8 0 000 1.6H18a.8.8 0 100-1.6zM6 5.948a.8.8 0 100 1.6h3a.8.8 0 100-1.6zM6.7 12.748a.8.8 0 01.8-.8h3a.8.8 0 110 1.6h-3a.8.8 0 01-.8-.8zM6 15.698a.8.8 0 000 1.6h3a.8.8 0 100-1.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3.75 2.198a1.55 1.55 0 00-1.55 1.55v15.7h-.7a.8.8 0 000 1.6h21a.8.8 0 100-1.6h-.7v-9.7a1.55 1.55 0 00-1.55-1.55H14.3v-4.45a1.55 1.55 0 00-1.55-1.55zm16.45 7.6v9.65h-5.9v-9.65zm-7.5-6v15.65H3.8V3.798z",
    fillRule: "evenodd"
  }))));
}

export default SvgBuildings;